import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MOBILE_BREAKPOINT_IN_PX } from '../../constants';

const UpperContainerWrapper = styled.div`
  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    display: none;
    max-height: 0;
  }
`;

const UpperContainer = ({ children }) => (
  <UpperContainerWrapper>{children}</UpperContainerWrapper>
);

UpperContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UpperContainer;
